import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';;

@Component({
  selector: 'app-mainlayout',
  templateUrl: './mainlayout.component.html',
  styleUrls: ['./mainlayout.component.less']
})
export class MainlayoutComponent implements OnInit {
  opened = false;
  mode = 'over';
  showLoader: boolean = false;

  constructor(private data: DataService) { }

  ngOnInit() {
    this.data.mobileMenu.subscribe(state => {
      this.opened = state;
    });

    this.data.dataLoading.subscribe(status => {
      this.showLoader = status;
    });
  }

  onClose(): void {
    this.data.toggleMobileMenu(false);
  }
}
